/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets ACESSPMVerificationList from api:
 * /v1/ua/aces_verifications
 *
 * @param {string} caseId.
 * @param {string} personId.
 * @param {any} callback function to call once this function has finished
 */
const fetchAcesVerificationsUtil = (caseId, personId, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/aces_verifications?caseId=${caseId}&personId=${personId}`,
    models.ACESSPMVerificationList
  );
};

/**
 * Gets ACESSPMVerification from api:
 * /v1/ua/aces_verifications/{verificationId}
 *
 * @param {string} verificationId.
 * @param {any} callback function to call once this function has finished
 */
const getAcesVerificationsByVerificationIdUtil = (verificationId, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/aces_verifications/${verificationId}`,
    models.ACESSPMVerification
  );
};

/**
 * Post request to path:
 * /v1/ua/aces_verifications/link_file
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesVerificationsLinkFileUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_verifications/link_file`;

  RESTService.post(url, data, (success, response) => {
    callback(success, response);
  });
};

/**
 * Deletes from api:
 * /v1/ua/aces_verifications/{verificationId}/file_links/{linkId}
 *
 * @param {string} verificationId.
 * @param {string} linkId.
 * @param {any} callback function to call once this function has finished
 */
const deleteAcesVerificationsFileLinksByLinkIdUtil = (verificationId, linkId, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_verifications/${verificationId}/file_links/${linkId}`;
  RESTService.del(url, (success, response) => {
    callback(success, response);
  });
};

/**
 * Post request to path:
 * /v1/ua/aces_verifications/create_caseworker_task
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesVerificationsCreateCaseworkerTaskUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_verifications/create_caseworker_task`;

  RESTService.post(url, data, (success, response) => {
    callback(success, response);
  });
};

export {
  fetchAcesVerificationsUtil,
  getAcesVerificationsByVerificationIdUtil,
  postAcesVerificationsLinkFileUtil,
  deleteAcesVerificationsFileLinksByLinkIdUtil,
  postAcesVerificationsCreateCaseworkerTaskUtil,
};
